export default __webpack_public_path__ + "static/media/1346.7cd88727.png";